import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Vipnet from 'services/vipnet';
import { Field, reduxForm } from 'redux-form/immutable';
import renderSelect from 'components/Select/reduxForm';
import renderField from 'components/Field/reduxForm';
import revokeReasonsOptions from './private/revokeReasonsOptions';
import { getRequiredFn } from 'utils/reduxForm/validations';
import Button from 'components/Button';
import { noop } from 'lodash';

const vipnet = new Vipnet();
const required = getRequiredFn();

class RevokeVipnetSertificate extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    autofill: PropTypes.func,
    onClose: PropTypes.func.isRequired,
  };
  certAvailable = true;

  async componentDidMount() {
    const { autofill } = this.props;
    try {
      const certificate = await vipnet.selectCertificate();
      autofill('certificateRequest', certificate.Base64RawData);
      autofill('serialNumber', certificate.SerialNumber);
    } catch (e) {
      this.certAvailable = false;
    }
  }

  render() {
    const { handleSubmit, onClose } = this.props;
    if (!this.certAvailable) {
      return (
        <p className="text-big">
          {'В данный момент сертификат не может быть отозван. Пожалуйста, повторите попытку позже'}
        </p>
      );
    }
    return (
      <form onSubmit={handleSubmit}>
        <h1 className="page_subtitle">Отзыв сертификата</h1>
        <Field name={'certificateRequest'} component={renderField} type={'hidden'} />
        <Field
          component={renderField}
          name={'serialNumber'}
          isDisabled={true}
          label={'Серийный номер сертификата'}
        />
        <Field
          component={renderSelect}
          isFull={true}
          label={'Причина отзыва'}
          name={'reason'}
          isRequired={true}
          options={revokeReasonsOptions}
          parse={({ value }) => value}
          validate={required}
        />
        <Field component={renderField} name={'description'} label={'Комментарий'} />
        <>
          <Button
            hasWrapper={false}
            type="button"
            onClick={onClose}
            buttonStyle={{ marginRight: '15px' }}
          >
            Отмена
          </Button>
          <Button hasWrapper={false} onClick={noop} type="submit" color={'orange'}>
            {'Отозвать сертификат'}
          </Button>
        </>
      </form>
    );
  }
}

export default reduxForm({
  form: 'revokeVipnet',
})(RevokeVipnetSertificate);
